window.queryTabs = function (key, defaultValue) {
    const queryParams = new URLSearchParams(window.location.search)

    const localStorageKey = 'query-tab:' + key + ':' + window.location.pathname

    let tab = defaultValue
    if (queryParams.has(key)) {
        tab = queryParams.get(key)
    } else {
        let saved = localStorage.getItem(localStorageKey)
        if (saved && saved.length > 0) {
            tab = saved
        }
    }

    return {
        tab: tab,

        selectTab (selected) {
            this.tab = selected
            queryParams.set(key, selected)
            localStorage.setItem(localStorageKey, selected)
            history.replaceState(null, null, '?' + queryParams.toString())
        },
    }
}
